var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveySocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.9998,
    y: 7.00073,
    width: 64,
    height: 83,
    rx: 2,
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7495,
    y: 26.7502,
    width: 45.5,
    height: 25.5,
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9995,
    y: 59.6658,
    width: 24.878,
    height: 4.16666,
    fill: "#8372FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9995,
    y: 68.0002,
    width: 24.878,
    height: 4.16667,
    fill: "#8372FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9995,
    y: 68.0002,
    width: 24.878,
    height: 4.16667,
    fill: "#8372FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9995,
    y: 76.3345,
    width: 36.2805,
    height: 4.16667,
    fill: "#8372FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9995 17.9998L88.9995 17.9998",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2193 14.8742C73.3642 14.8742 74.2924 13.9415 74.2924 12.7909C74.2924 11.6403 73.3642 10.7075 72.2193 10.7075C71.0743 10.7075 70.1461 11.6403 70.1461 12.7909C70.1461 13.9415 71.0743 14.8742 72.2193 14.8742ZM65.0727 14.8756C66.2177 14.8756 67.1459 13.9428 67.1459 12.7922C67.1459 11.6417 66.2177 10.7089 65.0727 10.7089C63.9277 10.7089 62.9995 11.6417 62.9995 12.7922C62.9995 13.9428 63.9277 14.8756 65.0727 14.8756ZM81.4391 12.7909C81.4391 13.9415 80.5109 14.8742 79.3659 14.8742C78.221 14.8742 77.2928 13.9415 77.2928 12.7909C77.2928 11.6403 78.221 10.7075 79.3659 10.7075C80.5109 10.7075 81.4391 11.6403 81.4391 12.7909Z",
    fill: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 69.5596L76.4855 63.1491C74.0434 60.179 72.578 56.3931 72.578 52.2678C72.578 42.7305 80.3996 34.9993 90.0484 34.9993C99.6967 34.9993 107.518 42.7305 107.518 52.2678C107.518 61.8051 99.6967 69.5363 90.0484 69.5363C84.6423 69.5363 76.5011 69.5596 70 69.5596Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8756 45.2798C87.7747 45.044 89.4155 46.0501 90.3211 47.594C91.2269 46.0499 92.8681 45.0437 94.7677 45.2798L94.7678 45.2798C96.9972 45.557 98.6781 47.5751 98.8686 49.9139L98.8686 49.914C99.0002 51.5314 98.4508 53.03 97.4773 54.0744V54.1251L97.2285 54.3249L97.0515 54.5044L97.0255 54.5307L97.0222 54.534L97.0217 54.5345L97.0216 54.5346L97.0216 54.5347L97.0213 54.5349L97.0213 54.5349L97.0209 54.5353L97.0209 54.5353L97.0198 54.5365L97.0181 54.5382L96.9922 54.5645L96.7847 54.7748L96.7847 54.7749L96.7791 54.7804L90.85 60.6669L90.3224 61.1908L89.7939 60.6676L83.8486 54.7811L83.8408 54.7734L83.8332 54.7654C83.599 54.5194 83.5193 54.431 83.4766 54.3834L83.4634 54.3689C83.4591 54.3648 83.4508 54.3569 83.4271 54.3348L83.1659 54.1251V54.0744C82.1925 53.0297 81.6431 51.5308 81.7746 49.9134C81.9644 47.5746 83.6463 45.5565 85.8756 45.2798Z",
    fill: "#FFBB00",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySocial);
export default __webpack_public_path__ + "static/media/survey-social.8b0e5bfa.svg";
export { ForwardRef as ReactComponent };